import Swiper from 'swiper/bundle'; // css file is added locally

const $body = $('body');

let fontSize = parseFloat($('body').css('font-size'));

$(window).on('resize', function () {
    fontSize = parseFloat($('body').css('font-size'));
});

$body.on('initScripts', function () {
    const swiperCards = new Swiper('.cards__slider:not(.cards__slider--large)', {
        slidesPerView: 1,
        spaceBetween: (fontSize*1.5),
        speed: !!prefersReducedMotion ? 0 : 300,
        autoHeight: true,
        breakpoints: {
            401: {
                slidesPerView: 1.1,
                spaceBetween: (fontSize*1.5),
                autoHeight: false,
            },
            690: {
                slidesPerView: 2,
                spaceBetween: (fontSize*2),
                autoHeight: false,
            },
            1159: {
                slidesPerView: 3,
                spaceBetween: (fontSize*2),
                autoHeight: false,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    });

    const swiperCardsLarge = new Swiper('.cards__slider.cards__slider--large', {
        slidesPerView: 1,
        spaceBetween: (fontSize*1.5),
        speed: !!prefersReducedMotion ? 0 : 300,
        autoHeight: true,
        breakpoints: {
            401: {
                slidesPerView: 1.1,
                spaceBetween: (fontSize*1.5),
                autoHeight: false,
            },
            890: {
                slidesPerView: 2,
                spaceBetween: (fontSize*2),
                autoHeight: false,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    });

    const swiperServices = new Swiper('.services__slider', {
        slidesPerView: 1,
        spaceBetween: (fontSize*1.5),
        speed: !!prefersReducedMotion ? 0 : 300,
        autoHeight: true,
        breakpoints: {
            401: {
                slidesPerView: 1.1,
                spaceBetween: (fontSize*1.5),
                autoHeight: false,
            },
            690: {
                slidesPerView: 2,
                spaceBetween: (fontSize*2),
                autoHeight: false,
            },
            1159: {
                slidesPerView: 3,
                spaceBetween: (fontSize*2),
                autoHeight: false,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    });

    const swiperCases = new Swiper('.cases__slider', {
        slidesPerView: 1,
        spaceBetween: (fontSize*1.5),
        speed: !!prefersReducedMotion ? 0 : 300,
        autoHeight: true,
        breakpoints: {
            401: {
                slidesPerView: 1.1,
                spaceBetween: (fontSize*1.5),
                autoHeight: false,
            },
            1112: {
                slidesPerView: 2,
                spaceBetween: (fontSize*2),
                autoHeight: false,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    });

    const swiperGallery = new Swiper('.gallery__slider', {
        slidesPerView: 'auto',
        spaceBetween: fontSize,
        //centeredSlides: true,
        speed: 300,
        //rewind: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        on: {
            resize: function () {
                this.update();
            },
        },
    });
});
